/* Small shared helpers for the core pages group. */
import type { Employee, ExpiringDoc } from "../../../data/types";
import { ApiError } from "../../../data/provider";

export function docIcon(kind: string): string {
  if (/iqama|national id/i.test(kind)) return "id-card";
  if (/insurance/i.test(kind)) return "shield";
  if (/visa/i.test(kind)) return "plane";
  return "file";
}

/** Join expiring docs with their employees (drops docs whose employee isn't loaded). */
export function withEmployees(list: ExpiringDoc[], emps: Employee[]): { e: Employee; d: ExpiringDoc }[] {
  const by = new Map(emps.map((e) => [e.id, e]));
  const out: { e: Employee; d: ExpiringDoc }[] = [];
  for (const d of list) { const e = by.get(d.employeeId); if (e) out.push({ e, d }); }
  return out;
}

export const isSaudi = (e: { nationality: string }) => e.nationality === "SA";

/** Field errors from a 422 ApiError (empty object otherwise). */
export function fieldErrors(e: unknown): Record<string, string> {
  return e instanceof ApiError && e.fields ? e.fields : {};
}

/** Roles that may write employees / renew documents / run HR modules. */
export const canWriteHr = (role: string | null | undefined) => role === "owner" || role === "hr";

/** Arabic labels for dependant relations. */
export const REL_AR: Record<string, string> = { Spouse: "زوج/ة", Wife: "زوجة", Husband: "زوج", Son: "ابن", Daughter: "ابنة", Child: "ابن/ابنة", Father: "أب", Mother: "أم" };
